"use strict";

exports.__esModule = true;
exports.default = void 0;

var _toggle = require("./toggle");

var _plugins = require("../../utils/plugins");

var directives = {
  BToggle: _toggle.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/toggle/index.js
// module id = n9qK
// module chunks = 14